
import * as React from 'react';
import { connectToItemCache } from '../../decorators/connectToItemCache';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { IDateFieldProps, DateField } from './DateField';
import { dateModifiedFacet } from '../../../facets/ItemFacets';
import { localeFacet, configurationItemKey } from '../../../facets/ConfigurationFacets';
import { getRelativeDateTimeStringPast } from '@ms/utilities-date-time/lib/relativePast';
import { ISpecifiedItemProps } from '../../decorators/selectors';
import { IDecoratedProps } from '../../../utilities/components/Decorators';

export type IDateRendererProps = IDecoratedProps<IDateFieldProps, {}, ISpecifiedItemProps>;

export const DateRenderer: React.ComponentType<IDateRendererProps> = connectToItemCache((
  itemCache: IItemCache,
  props: ISpecifiedItemProps
): Pick<IDateFieldProps, 'dateValue' | 'text'> => {
  const dateModified = itemCache.demandItemFacet(dateModifiedFacet, props.itemKey);
  const time = dateModified && new Date(dateModified).getTime();

  if (typeof time === 'number' && !isNaN(time)) {
    const locale = itemCache.demandItemFacet(localeFacet, configurationItemKey);

    const language = locale && locale.language || window.navigator.language;

    return language ? {
      text: getRelativeDateTimeStringPast(new Date(time), language)
    } : {
        dateValue: time
      };
  } else {
    return {
      text: ''
    };
  }
})(DateField);
